import { useContext, useEffect, useRef, useState } from "react";
import SuccessToast from "../toasts/SuccessToast";
import { MqttContext } from "../../context/MQTTContext";
import './SetDeviceTimeModal.css';

const SetDeviceTimeModal = ({ setDeviceTime, deviceTime, time, device }) => {
  const { clients } = useContext(MqttContext);

  const [timezone, setTimezone] = useState(0);
  const [dst, setDst] = useState(0);
  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  const modalName = useRef(0);
  const closeButton = useRef(0);

  useEffect(() => {
    setDeviceTime(modalName);

    modalName.current.addEventListener("shown.bs.modal", function () {
      setTimezone(time.current[0]);
      setDst(time.current[1]);
      setDay(time.current[2]);
      setHour(time.current[3]);
      setMin(time.current[4]);
      setSec(time.current[5]);
    });
  }, []);

  const handleChangeDst = () => {
    setDst(dst ? 0 : 1);
  };

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleSubmitTime = () => {
    if (!clients[device.id]) return;

    const messageListener = (topic, message) => {
      const endOfTwoCharToken =
        String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
      if (
        device.internet_token.slice(-2) === endOfTwoCharToken &&
        message[2] == 9
      ) {
        closeButton.current.click();
        SuccessToast("زمان با موفقیت بروزرسانی شد");
      }
    };
    clients[device.id].on("message", messageListener);
    let buffer = new ArrayBuffer(7);
    let asciiCode = new Uint8Array(buffer);
    asciiCode[0] = 9;
    asciiCode[1] = timezone;
    asciiCode[2] = dst;
    asciiCode[3] = day;
    asciiCode[4] = hour;
    asciiCode[5] = min;
    asciiCode[6] = sec;
    let message = device.internet_token;
    let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
    clients[device.id].publish(device.serial + "/sys", combinedMessage);
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="scenarioTimerModal"
      tabIndex="-1"
      aria-labelledby="scenarioTimerModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              بروز رسانی زمان
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-lable mb-1">منطقه زمانی +GMT</label>
              <select
                id="timezone"
                className="form-select w-100"
                data-style="btn-default"
                value={timezone ? timezone : 0}
                onChange={(e) => setTimezone(e.target.value)}
              >
                <option value="208">-12</option>
                <option value="210">-11.5</option>
                <option value="212">-11</option>
                <option value="214">-10.5</option>
                <option value="216">-10</option>
                <option value="218">-9.5</option>
                <option value="220">-9</option>
                <option value="222">-8.5</option>
                <option value="224">-8</option>
                <option value="226">-7.5</option>
                <option value="228">-7</option>
                <option value="230">-6.5</option>
                <option value="232">-6</option>
                <option value="234">-5.5</option>
                <option value="236">-5</option>
                <option value="238">-4.5</option>
                <option value="240">-4</option>
                <option value="242">-3.5</option>
                <option value="244">-3</option>
                <option value="246">-2.5</option>
                <option value="248">-2</option>
                <option value="250">-1.5</option>
                <option value="252">-1</option>
                <option value="0">0</option>
                <option value="4">1</option>
                <option value="6">1.5</option>
                <option value="8">2</option>
                <option value="10">2.5</option>
                <option value="12">3</option>
                <option value="14">3.5</option>
                <option value="16">4</option>
                <option value="18">4.5</option>
                <option value="20">5</option>
                <option value="22">5.5</option>
                <option value="24">6</option>
                <option value="26">6.5</option>
                <option value="28">7</option>
                <option value="30">7.5</option>
                <option value="32">8</option>
                <option value="34">8.5</option>
                <option value="36">9</option>
                <option value="38">9.5</option>
                <option value="40">10</option>
                <option value="42">10.5</option>
                <option value="44">11</option>
                <option value="46">11.5</option>
                <option value="48">12</option>
              </select>
            </div>
            <div className="mb-3 user-select-none">
              <label className="switch switch-success-app switch-full-width">
                <input
                  type="checkbox"
                  className="switch-input"
                  onChange={handleChangeDst}
                  checked={dst ? "checked" : ""}
                />
                <span className="switch-toggle-slider">
                  <span className="switch-on"></span>
                  <span className="switch-off"></span>
                </span>
                <span className="switch-label">تغییر ساعت تابستانه</span>
              </label>
            </div>
            <div className="row mb-3">
              <div className="col-12 col-sm-9 col-md-8">
                <div className="d-flex justify-content-center justify-content-sm-end">
                  {/* second */}
                  <select
                    id="sec"
                    className="form-select border-0 text-center w-auto"
                    data-style="btn-default"
                    value={sec}
                    onChange={(e) => setSec(e.target.value)}
                  >
                    <option value="0">00</option>
                    <option value="1">01</option>
                    <option value="2">02</option>
                    <option value="3">03</option>
                    <option value="4">04</option>
                    <option value="5">05</option>
                    <option value="6">06</option>
                    <option value="7">07</option>
                    <option value="8">08</option>
                    <option value="9">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                    <option value="33">33</option>
                    <option value="34">34</option>
                    <option value="35">35</option>
                    <option value="36">36</option>
                    <option value="37">37</option>
                    <option value="38">38</option>
                    <option value="39">39</option>
                    <option value="40">40</option>
                    <option value="41">41</option>
                    <option value="42">42</option>
                    <option value="43">43</option>
                    <option value="44">44</option>
                    <option value="45">45</option>
                    <option value="46">46</option>
                    <option value="47">47</option>
                    <option value="48">48</option>
                    <option value="49">49</option>
                    <option value="50">50</option>
                    <option value="51">51</option>
                    <option value="52">52</option>
                    <option value="53">53</option>
                    <option value="54">54</option>
                    <option value="55">55</option>
                    <option value="56">56</option>
                    <option value="57">57</option>
                    <option value="58">58</option>
                    <option value="59">59</option>
                  </select>
                  <span className="align-content-center">:</span>
                  {/* minute */}
                  <select
                    id="min"
                    className="form-select border-0 text-center w-auto"
                    data-style="btn-default"
                    value={min}
                    onChange={(e) => setMin(e.target.value)}
                  >
                    <option value="0">00</option>
                    <option value="1">01</option>
                    <option value="2">02</option>
                    <option value="3">03</option>
                    <option value="4">04</option>
                    <option value="5">05</option>
                    <option value="6">06</option>
                    <option value="7">07</option>
                    <option value="8">08</option>
                    <option value="9">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                    <option value="33">33</option>
                    <option value="34">34</option>
                    <option value="35">35</option>
                    <option value="36">36</option>
                    <option value="37">37</option>
                    <option value="38">38</option>
                    <option value="39">39</option>
                    <option value="40">40</option>
                    <option value="41">41</option>
                    <option value="42">42</option>
                    <option value="43">43</option>
                    <option value="44">44</option>
                    <option value="45">45</option>
                    <option value="46">46</option>
                    <option value="47">47</option>
                    <option value="48">48</option>
                    <option value="49">49</option>
                    <option value="50">50</option>
                    <option value="51">51</option>
                    <option value="52">52</option>
                    <option value="53">53</option>
                    <option value="54">54</option>
                    <option value="55">55</option>
                    <option value="56">56</option>
                    <option value="57">57</option>
                    <option value="58">58</option>
                    <option value="59">59</option>
                  </select>
                  <span className="align-content-center">:</span>
                  {/* hour */}
                  <select
                    id="hour"
                    className="form-select border-0 text-center w-auto"
                    data-style="btn-default"
                    value={hour}
                    onChange={(e) => setHour(e.target.value)}
                  >
                    <option value="0">00</option>
                    <option value="1">01</option>
                    <option value="2">02</option>
                    <option value="3">03</option>
                    <option value="4">04</option>
                    <option value="5">05</option>
                    <option value="6">06</option>
                    <option value="7">07</option>
                    <option value="8">08</option>
                    <option value="9">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                  </select>
                </div>
              </div>
              <div className="col-12 col-sm-3 col-md-4">
                {/* day */}
                <select
                  id="day"
                  className="form-select w-100"
                  data-style="btn-default"
                  value={day}
                  onChange={(e) => setDay(e.target.value)}
                >
                  <option value="0">شنبه</option>
                  <option value="1">یکشنبه</option>
                  <option value="2">دوشنبه</option>
                  <option value="3">سه‌شنبه</option>
                  <option value="4">چهارشنبه</option>
                  <option value="5">پنج‌‍شنبه</option>
                  <option value="6">جمعه</option>
                </select>
              </div>
            </div>
            <div>
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButton}
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-3 mb-2"
              onClick={handleSubmitTime}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetDeviceTimeModal;
